angular.module("events")
    .controller("EventsWorkTeamListCtrl", ['$http', 'event', '$rootScope', '$scope', 'Restangular', 'notificationService', 'modalService', '$uibModal', '$filter', '$translate', '$stateParams', '$state', 'LoginService', 'logService',
        function ($http, event, $rootScope, $scope, Restangular, notificationService, modalService, $uibModal, $filter, $translate, $stateParams, $state, LoginService, logService) {

            logService.debug($stateParams.edit);
            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("EVENTS_WORK_TEAM_WRITE");
            $scope.allowReadUsers = LoginService.permissionExist("USERS_READ");
            if(!Array.isArray($scope.$parent.menusItems)) {
                $state.go("events.edit", { id: $stateParams.id });
            } else {
                let results = $scope.$parent.menusItems.filter(m => m.id === parseInt($stateParams.menu_item_id, 10));
                if(results.length > 0) {
                    $scope.allowWrite &&= results[0].editable;
                } else {
                    $scope.allowWrite = false;
                }
            }
            $scope.is_template = $stateParams.is_template == 'true';
            var eventUsersIds = [];
            $scope.work_team = {};
            $scope.addresses = [];
            $scope.search = {};
            $scope.classSize = "col-lg-12 col-md-12";
            function isDefinedAndNotNull(val) {
                return angular.isDefined(val) && val !== null
            }

            $rootScope.title = event.name + " - " +$filter('translate')('events.work_team.work_team');
            $rootScope.breadcrumb = [
            { title: $filter('translate')('events.title'), url: "events.list" },
            { title: event.name, url: "events.edit({ id: " + event.id + " })" },
            { title: $filter('translate')('events.work_team.work_team') }
            ];

            $scope.loadData = function () {
                Restangular.all('EventsUsers').getList({ event_id: $stateParams.id }).then(function (results) {
                    $scope.eventUsers = results;
                    var direcciones = "";

                    angular.forEach($scope.eventUsers, function (eventUser) {
                        if (eventUser.FK_events_users_users.mail != null) {
                            $scope.addresses.push(eventUser.FK_events_users_users.mail);
                        }
                        if (eventUsersIds.indexOf(eventUser.user_id) < 0) {
                            eventUsersIds.push(eventUser.user_id);
                        }
                    });

                    if (eventUsersIds.length > 0) {
                        $http({
                            method: 'post',
                            url: (window as any).CONFIG.api_url + 'Users/ImagesSmall',
                            params: { ids: eventUsersIds }
                        }).then(function (resultsImg, status, headers, config) {
                            angular.forEach(results, function (event_user) {

                                for (var i = 0; i < resultsImg.data.length; i++) {
                                    if (event_user.user_id == resultsImg.data[i].user_id) {
                                        if (angular.isDefined(event_user.FK_events_users_users)) {
                                            event_user.FK_events_users_users.FK_users_images = {};
                                            event_user.FK_events_users_users.FK_users_images.image = resultsImg.data[i].image_small;
                                        }
                                        break;
                                    }
                                }
                            });
                        });
                    }
                });
            }

            $scope.loadData();

            Restangular.all('Users').getList().then(function (users) {
                $scope.selectUsers = users;
            });

            $scope.searchFilter = function (value) {

                var index = $.inArray(value.FK_events_users_users.mail, $scope.addresses);
                if (value.FK_events_users_users.mail != null && index > -1) {
                    $scope.addresses.splice(index, 1);
                }
                if (angular.isUndefined($scope.search.value) ||
                    value.FK_events_users_users.name.toLowerCase().indexOf($scope.search.value.toLowerCase()) > -1 ||
                    value.FK_events_users_events_users_profiles.name.toLowerCase().indexOf($scope.search.value.toLowerCase()) > -1) {
                    if (value.FK_events_users_users.mail != null) $scope.addresses.push(value.FK_events_users_users.mail);
                    return true;
                } else {
                    return false;
                }
            }

            $scope.filterUsers = function (value) {
                if (angular.isDefined(eventUsersIds) && eventUsersIds.indexOf(value.id) == -1) {
                    return true;
                } else {
                    return false;
                }
            }


            Restangular.all('EventsUsersProfiles').getList().then(function (profiles) {
                $scope.selectProfiles = profiles;
            });

            $scope.addEventUser = function (frmWorkTeam) {

                var index = eventUsersIds.indexOf($scope.work_team.user.id);
                if (index == -1) {

                    eventUsersIds.push($scope.work_team.user.id);
                    let eventUser: any = {};
                    eventUser.event_id = $stateParams.id;
                    eventUser.FK_events_users_users = $scope.work_team.user;
                    eventUser.user_id = $scope.work_team.user.id;

                    eventUser.FK_events_users_events_users_profiles = $scope.work_team.profile;
                    eventUser.event_user_profile_id = $scope.work_team.profile.id
                    $scope.eventUsers.push(eventUser);
                }

                $scope.work_team.user = "";
                $scope.work_team.profile = "";


            };

            $scope.deleteEventUser = function (id,mail) {

                angular.forEach($scope.eventUsers, function (eventUser, idx) {
                    if (eventUser.user_id == id) {
                        $scope.eventUsers.splice(idx, 1);
                    }
                })

                var index = eventUsersIds.indexOf(id);
                eventUsersIds.splice(index, 1);
                index = $.inArray(mail, $scope.addresses);
                if (mail != null && index > -1) {
                    $scope.addresses.splice(index, 1);
                }
            }

            $scope.saveEventUser = function () {
                $scope.eventUserContainer = {};
                $scope.work_team;
                $scope.eventUserContainer.event_id = $stateParams.id;
                if ($scope.eventUsers.totalRows == 0) {
                    $scope.eventUsers.push({
                        user_id: $scope.work_team.user.id,
                        event_id: $stateParams.id,
                        event_user_profile_id: $scope.work_team.profile.id
                    })
                }
                $scope.eventUserContainer.events_users = $scope.eventUsers;
                Restangular.all('EventsUsers').post($scope.eventUserContainer).then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('events.edit_success'));
                        if ($scope.is_template) $state.go("events.list", { is_template: true });
                        $scope.loadData();
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }

            $scope.modalSendMail = function (mail_to) {
                var params = {
                    entity_type: "events",
                    entity_type_id: $stateParams.id,
                    users_ids: [mail_to],
                    mail_account_id: event.mail_account_id,
                    mail_account_reply: event.reply_to,
                    documents: { for_event_staff: true }
                };
                notificationService.notificationMail({
                    params: params,
                    onAccept: function (data) {
                        toastr.success($filter('translate')('notifications.sending_mail_success'));
                    }
                });
            }


            $scope.sendNotifications = function () {

                if (eventUsersIds.length == 0) {
                    modalService.message({
                        title: "Error",
                        message: $filter('translate')('events.guests.select_persons'),
                        onAccept: function () { }
                    });
                } else {
                    if (event.mail_account_id == null || event.mail_account_id == 0) {
                        modalService.message({
                            title: "Error",
                            message: $filter('translate')('events.select_mail_from_address'),
                            onAccept: function () { }
                        });
                    } else {
                        var params = {
                            entity_type: "events",
                            entity_type_id: $stateParams.id,
                            users_ids: eventUsersIds,
                            mail_account_id: event.mail_account_id,
                            mail_account_reply: event.reply_to,
                            documents: { for_event_staff: true }
                        };
                        notificationService.notificationMail({
                            params: params,
                            onAccept: function (data) {
                                toastr.success($filter('translate')('notifications.sending_mail_success'));
                            }
                        });
                    }
                }

            }


        }])

;
